// extracted by mini-css-extract-plugin
export default {"start":"Landing_start__LqWGW","jumbotron":"Landing_jumbotron__mAxup"};